module.exports = __webpack_public_path__ + "img/floor_OG3.15086732.svg";